import type { ReactNode } from 'react';

import { RealtimeContext } from './context';
import type { RealtimeManager } from './manager';

export function RealtimeProvider({ manager, children }: { manager: RealtimeManager; children: ReactNode }) {
  return <RealtimeContext value={manager}>{children}</RealtimeContext>;
}
